<template>
  <div class="pet-info-header" :style="{ background: headerBg }">
    <div class="pih__avatar">
      <img v-if="imageUrl" :src="imageUrl" class="pih__avatar-img" />
      <template v-else>🐾</template>
    </div>
    <div class="pih__main">
      <div class="pih__top">
        <span class="pih__name">{{ name || "버츄펫" }}</span>
        <span class="pih__lv">Lv {{ level }}</span>
      </div>
      <div class="pih__expbar">
        <div class="pih__expfill" :style="{ width: pct + '%' }"></div>
      </div>
      <div class="pih__exptext">{{ currentExp.toLocaleString() }} / {{ nextExp.toLocaleString() }} EXP</div>
    </div>
    <v-btn icon dark class="pih__close" @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
  </div>
</template>

<script>
import SupabaseApi from "@/api/SupabaseApi";

// 레벨 경험치 곡선 (levelExpDataMixin과 동일 규칙)
const FIXED_EXP = 100;
function levelMaxExp(level) {
  let t = 0;
  for (let i = 0; i < level; i++) t += FIXED_EXP * (Math.floor(i / 10) + 1);
  return t;
}
function currentExpInLevel(level, totalExp) {
  if (level <= 1) return totalExp;
  let c = totalExp;
  for (let l = 1; l < level; l++) c -= levelMaxExp(l);
  return c;
}

export default {
  name: "PetInfoHeader",
  props: {
    petColor: { type: String, default: "#8e6fd6" },
  },
  data() {
    return {
      name: "",
      imageUrl: "",
      level: 1,
      currentExp: 0,
      nextExp: 0,
    };
  },
  computed: {
    pct() {
      return this.nextExp > 0 ? Math.min(100, Math.round((this.currentExp / this.nextExp) * 100)) : 0;
    },
    // 헤더 배경 = 모델 퍼스널 컬러 (밝은쪽 → 약간 어둡게 그라데이션)
    headerBg() {
      const c = this.petColor || "#8e6fd6";
      return `linear-gradient(135deg, ${c}, ${this._dim(c, 0.78)})`;
    },
  },
  async created() {
    try {
      const [profile, meta] = await Promise.all([
        SupabaseApi.PetProfile.fetchProfile(),
        SupabaseApi.fetchMyVirtupetLevelMeta(),
      ]);
      this.name = (profile && profile.name) || "";
      this.imageUrl = (profile && profile.imageUrl) || "";
      const level = (meta && meta.level) || 1;
      const totalExp = (meta && meta.totalExp) || 0;
      this.level = level;
      this.currentExp = currentExpInLevel(level, totalExp);
      this.nextExp = levelMaxExp(level);
    } catch (e) {
      console.error("PetInfoHeader load failed", e);
    }
  },
  methods: {
    // hex를 black 방향으로 f배(0~1) 어둡게 → rgb()
    _dim(hex, f) {
      const m = String(hex).replace("#", "").match(/.{2}/g);
      if (!m) return hex;
      const [r, g, b] = m.map((h) => Math.round(parseInt(h, 16) * f));
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
};
</script>

<style scoped>
.pet-info-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  color: #fff;
}
.pih__avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  flex: 0 0 52px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
}
.pih__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.pih__close {
  flex: 0 0 auto;
  align-self: flex-start;
}
.pih__main {
  flex: 1 1 auto;
  min-width: 0;
}
.pih__top {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.pih__name {
  font-size: 18px;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pih__lv {
  font-size: 12px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.25);
  padding: 1px 8px;
  border-radius: 999px;
  flex: 0 0 auto;
}
.pih__expbar {
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.25);
  margin-top: 8px;
  overflow: hidden;
}
.pih__expfill {
  height: 100%;
  background: #ffd54f;
  transition: width 0.3s;
}
.pih__exptext {
  font-size: 11px;
  margin-top: 4px;
  opacity: 0.9;
}
</style>
